
import {defineComponent} from 'vue';
import MyDescription from "@/components/SectionApresentetion/MyDescription.vue";
import MyPerfil from "@/components/SectionApresentetion/MyPerfil.vue";
import MyImagemFullStack from "@/components/SectionApresentetion/MyImagemFullStack.vue";
import MyStacks from "@/components/SectionApresentetion/MyStacks.vue";

export default defineComponent({
  name: 'SectionApresention',
  components: {MyStacks, MyImagemFullStack, MyPerfil, MyDescription}
});
